import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./modelos-gps.component.html')
})
export class ModelosGpsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/modelos-gps/modelos-gps.component.ts
 **/